import { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  TextInput,
  Select,
  Title,
  Accordion, Space
} from "@mantine/core";
import JoditEditor from "jodit-react";
import { message, Table } from "antd";
import { Adminauthcontexthooks } from "../../Hooks/Adminauthcontexthooks";

const AddLegalUpdate = () => {

  const { user } = Adminauthcontexthooks();
  const editor = useRef(null);
  const [title, setTitle] = useState("");
  const [shortdescription, setShortdescription] = useState("");
  const [category, setCategory] = useState("");
  const [subdistcourt, setSubdistrictcourt] = useState("");
  const [content, setContent] = useState("");
  const [publishloading, setPublishloading] = useState(false);
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(true);
  const [Deletebtnloading, setDeletebtnloading] = useState(false);

  const PublishUpdate = async () => {
    if (!title || !content || !category || (category === 'District Court' && !subdistcourt) || !shortdescription) {
      message.error("Please fill in all required fields");
      return;
    }
    setPublishloading(true);
    const res = await fetch(
      "https://cdr-backend.onrender.com/add/legal-update",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${user}`
        },
        body: JSON.stringify({
          title,
          shortdescription,
          category,
          subdistcourt,
          content
        })
      }
    );

    //const data = await res.json();
    if (res.status === 201) {
      message.success("Update Published");
      setTitle("");
      setShortdescription("");
      setCategory("");
      setSubdistrictcourt("");
      setContent("");
      setPublishloading(false);
      return;
    }
    else {
      message.error("Error publishing update");
      setPublishloading(false);
      return;
    }
  };
  const Getlegalupdates = async () => {
    const res = await fetch('https://cdr-backend.onrender.com/get/legal-updates', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user}`
      }

    });
    const data = await res.json();
    if (res.status === 200) {
      setdata(data.LegalupdatesOBJ);
      setloading(false);
    }
  }
  const Deleteupdate = async (obj) => {
    const id = obj._id;
    setDeletebtnloading(true);
    const res = await fetch(`https://cdr-backend.onrender.com/delete/legal_update/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user}`
      }
    });
    if (res.status === 200) {
      message.success("Deleted successfully");
      setDeletebtnloading(false);
      Getlegalupdates();
      return;
    } else {
      message.error("Something went wrong");
      setDeletebtnloading(false);
      return;
    }
  }
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Short Description',
      dataIndex: 'shortdescription',
      key: 'shortdescription',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Delete published update',
      key: 'delete_action',
      render: (id, record) => (
        <Space size="middle">
          <Button color="red" variant="light" onClick={() => Deleteupdate(id)} loading={Deletebtnloading}>Delete</Button>
        </Space>
      ),
    }
  ]
  useEffect(() => {
    if (user) {
      const Getlegalupdates = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/legal-updates', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }

        });
        const data = await res.json();
        if (res.status === 200) {
          setdata(data.LegalupdatesOBJ);
          setloading(false);
        }
      }
      Getlegalupdates()
    }

  }, [data, user])

  return (
    <Container size="lg">
      <Paper p="xl" radius="xl">

        <Title order={2} mb="lg">
          Publish Legal Update
        </Title>
        <Accordion>
          <Accordion.Item value="1">
            <Accordion.Control>Publish legal updates here</Accordion.Control>
            <Accordion.Panel>
              <Box>
                <TextInput
                  label="Update Title"
                  placeholder="Enter title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  mb="md"
                  required
                />

                <TextInput
                  label="Short Description"
                  placeholder="Short description"
                  value={shortdescription}
                  onChange={(e) => setShortdescription(e.target.value)}
                  mb="md"
                  required
                />

                <Select
                  label="Category"
                  placeholder="Select category"
                  data={[
                    'Supreme Court',
                    'High Court',
                    'District Court',
                  ]}
                  value={category}
                  onChange={setCategory}
                  mb="md"
                  required
                />
                {
                  category === 'District Court' && (
                    <Select
                      label="Select District Court"
                      placeholder="Select category"
                      data={['Tis Hazari courts', 'Rouse Avenue courts', 'Karkardooma courts', 'Patiala House courts', 'Rohini courts', 'Dwarka courts', 'Saket courts']}
                      value={subdistcourt}
                      onChange={setSubdistrictcourt}
                      mb="md"
                      required
                    />
                  )
                }
                <JoditEditor
                  ref={editor}
                  value={content}
                  onBlur={(newContent) => setContent(newContent)}
                />

                <Button
                  fullWidth
                  mt="xl"
                  radius="xl"
                  onClick={PublishUpdate}
                  loading={publishloading}
                >
                  Publish Update
                </Button>
              </Box>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
        <Box mt={'lg'}>
          <Table columns={columns} dataSource={data} loading={loading} />
        </Box>

      </Paper>

    </Container>
  );
};

export default AddLegalUpdate;